import React, { FC } from 'react';

import { WithAlloySuspense } from '@adsk/alloy-react-suspense';

import ConnectedAttachments, {
  ConnectedAttachmentsProps,
} from './ConnectedAttachments';
import AttachmentsProvider, {
  type AttachmentsProviderProps,
} from './context/AttachmentsProvider';

export type AttachmentsProps = ConnectedAttachmentsProps &
  AttachmentsProviderProps;

const Attachments: FC<AttachmentsProps> = ({
  style,
  className,
  listHeight,
  openAttachmentWith,
  renderHeader,
  renderDropzone,
  maxFileSize,
  maxNumberOfAttachments,
  acceptFileTypes,
  getCustomItemActions,
  variant,
  showVariantToggle,
  customDropzoneTitle,
  totalAttachments,
  controlledAttachmentId,
  onViewerOpenChange,
  onFileHandled,
  shouldAutoHandleNonViewable,
  ...props
}) => {
  return (
    <AttachmentsProvider
      totalAttachments={totalAttachments}
      maxFileSize={maxFileSize}
      maxNumberOfAttachments={maxNumberOfAttachments}
      controlledAttachmentId={controlledAttachmentId}
      onViewerOpenChange={onViewerOpenChange}
      onFileHandled={onFileHandled}
      shouldAutoHandleNonViewable={shouldAutoHandleNonViewable}
      {...props}
    >
      <ConnectedAttachments
        className={className}
        style={style}
        listHeight={listHeight}
        openAttachmentWith={openAttachmentWith}
        renderHeader={renderHeader}
        renderDropzone={renderDropzone}
        maxFileSize={maxFileSize}
        acceptFileTypes={acceptFileTypes}
        getCustomItemActions={getCustomItemActions}
        variant={variant}
        showVariantToggle={showVariantToggle}
        customDropzoneTitle={customDropzoneTitle}
      />
    </AttachmentsProvider>
  );
};

Attachments.displayName = 'Attachments';

export default WithAlloySuspense(Attachments);
